import { documentTypePreviewImageMap } from "Common/dictionaries/documentType";
import classNames from "classnames";
import React, { useMemo } from "react";
export default function DocumentPreviewImage(props) {
    const divStyle = useMemo(() => ({ width: props.width, height: props.height }), [props.width, props.height]);
    return documentTypePreviewImageMap[props.documentType] ? (React.createElement("img", { onClick: props.onClick, className: classNames("img-cover", props.className), height: props.height, width: props.width, src: documentTypePreviewImageMap[props.documentType] })) : (React.createElement("div", { onClick: props.onClick, className: classNames("bg-gray-050", props.className), style: divStyle }));
}
DocumentPreviewImage.defaultProps = {
    width: 261,
    height: 90
};
